// extracted by mini-css-extract-plugin
export default {"highlightsContainer":"style_highlightsContainer__6TYxS"};